<tec-item
    [tagImage]="{ icon: operationTypeIcon }"
    [title]="detail?.name"
    [detailAction]="detail?.company"
    [clickeable]="false"
>
    @if (statusTagLabelKey; as statusKey) {
        <tec-tag [label]="statusKey | translate" [status]="masterService.getTagStatus(effectiveState)" />
    } @else {
        <tec-tag [label]="'-'" [status]="'default'" />
    }

    <tec-list-detail>
        <app-uuid-flexible-display [uuid]="detail?.uuid" [label]="'OPERATIONS.DETAIL.ID_OPERATION_ABREV' | translate" />

        @if (detail?.id_client || detail?.identity?.uuid) {
            <tec-info-group>
                <b>{{ 'OPERATIONS.DETAIL.ID_IDENT' | translate }}</b>
                {{ detail?.id_client ?? ('GENERAL.NOT_AVAILABLE' | translate) }}
            </tec-info-group>
        }

        @if (detail?.operation_type_name !== OPERATION_TYPE.DOCUMENTS) {
            <app-operation-detail-item-extra-info [detail]="detail" />
        }

        <tec-info-group>
            <tec-icon name="icon-calendar" />
            <b>{{ 'OPERATIONS.DETAIL.LAST_UPDATE' | translate }}</b>
            {{ detail?.end_at ? (detail?.end_at | date : 'dd/MM/yyyy - HH:mm') : ('GENERAL.NOT_AVAILABLE' | translate) }}
        </tec-info-group>
    </tec-list-detail>

    <tec-menu [options]="operationsHelper.getDetailMenuOpt(detail)" (valueChange)="itemMenuChange($event)">
        <tec-button-icon [icon]="'icon-more'" [type]="'default'" />
    </tec-menu>
</tec-item>
